"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@kyruus/button"));
var _menu = _interopRequireDefault(require("@kyruus/menu"));
var _styles = require("./styles");
var _calendarEvents = _interopRequireDefault(require("./calendar-events"));
const MODES = ['apple', 'google', 'outlook', 'yahoo'];
class AddToCalendar extends _react.default.Component {
  constructor(props) {
    var _context, _context2;
    super(props);
    this.handleClick = (0, _bind.default)(_context = this.handleClick).call(_context, this);
    this.handleClose = (0, _bind.default)(_context2 = this.handleClose).call(_context2, this);
    this.state = {
      anchorEl: null
    };
  }
  handleClick(event) {
    this.setState({
      anchorEl: event.currentTarget
    });
  }
  handleClose() {
    this.setState({
      anchorEl: null
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      id: "add-to-calendar-menu-button",
      "aria-haspopup": "menu",
      "aria-controls": "add-to-calendar-menu",
      "aria-expanded": !!this.state.anchorEl,
      mode: this.props.buttonMode,
      onClick: this.handleClick
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, this.props.text), /*#__PURE__*/_react.default.createElement(_styles.PaddedArrowDown, {
      "aria-hidden": "true",
      size: "1em"
    }))), /*#__PURE__*/_react.default.createElement(_menu.default, {
      id: "add-to-calendar-menu",
      role: "menu",
      anchorEl: this.state.anchorEl,
      open: !!this.state.anchorEl,
      onClose: this.handleClose,
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, (0, _map.default)(MODES).call(MODES, mode => /*#__PURE__*/_react.default.createElement(_calendarEvents.default, {
      key: mode,
      onClick: () => {
        this.handleClose();
        this.props.onEventClick(mode);
      },
      mode: mode,
      event: this.props.event,
      modeLabels: this.props.modeLabels
    }))));
  }
}
AddToCalendar.propTypes = {
  /**
   * The event object to create calendar events for (example in README & Story Source).
   */
  event: _propTypes.default.shape({
    /**
     * The title or name of the event
     */
    title: _propTypes.default.string.isRequired,
    /**
     * Some additional information describing the event
     */
    details: _propTypes.default.string.isRequired,
    /**
     * The location where the event will take place
     */
    location: _propTypes.default.string.isRequired,
    /**
     * ISO8601 UTC string indicating when the event will start
     */
    start: _propTypes.default.string.isRequired,
    /**
     * ISO8601 UTC string indicating when the event will end
     */
    end: _propTypes.default.string.isRequired
  }).isRequired,
  /**
   * Called with the mode string when an event link is clicked (useful for logging ex: mode => LOG(`${mode} was clicked`) )
   */
  onEventClick: _propTypes.default.func,
  /**
   * Button text. If not set, text will default to 'Add To Calendar'
   */
  text: _propTypes.default.string,
  /**
   * Ability to configure text for calendar options. If not set, text defaults.
   */
  modeLabels: _propTypes.default.shape({
    apple: _propTypes.default.string,
    google: _propTypes.default.string,
    outlook: _propTypes.default.string,
    yahoo: _propTypes.default.string
  }),
  /**
   * The style of the button
   */
  buttonMode: _propTypes.default.oneOf(['flat', 'primary', 'secondary', 'tertiary', 'quaternary', 'ghost', 'contrast', 'floating-primary'])
};
AddToCalendar.defaultProps = {
  onEventClick: () => {},
  text: 'Add to Calendar',
  modeLabels: {},
  buttonMode: 'primary'
};
var _default = exports.default = AddToCalendar;
AddToCalendar.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleClose",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "AddToCalendar",
  "props": {
    "onEventClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Called with the mode string when an event link is clicked (useful for logging ex: mode => LOG(`${mode} was clicked`) )",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "text": {
      "defaultValue": {
        "value": "'Add to Calendar'",
        "computed": false
      },
      "description": "Button text. If not set, text will default to 'Add To Calendar'",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "modeLabels": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "Ability to configure text for calendar options. If not set, text defaults.",
      "type": {
        "name": "shape",
        "value": {
          "apple": {
            "name": "string",
            "required": false
          },
          "google": {
            "name": "string",
            "required": false
          },
          "outlook": {
            "name": "string",
            "required": false
          },
          "yahoo": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "buttonMode": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "The style of the button",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'flat'",
          "computed": false
        }, {
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'quaternary'",
          "computed": false
        }, {
          "value": "'ghost'",
          "computed": false
        }, {
          "value": "'contrast'",
          "computed": false
        }, {
          "value": "'floating-primary'",
          "computed": false
        }]
      },
      "required": false
    },
    "event": {
      "description": "The event object to create calendar events for (example in README & Story Source).",
      "type": {
        "name": "shape",
        "value": {
          "title": {
            "name": "string",
            "description": "The title or name of the event",
            "required": true
          },
          "details": {
            "name": "string",
            "description": "Some additional information describing the event",
            "required": true
          },
          "location": {
            "name": "string",
            "description": "The location where the event will take place",
            "required": true
          },
          "start": {
            "name": "string",
            "description": "ISO8601 UTC string indicating when the event will start",
            "required": true
          },
          "end": {
            "name": "string",
            "description": "ISO8601 UTC string indicating when the event will end",
            "required": true
          }
        }
      },
      "required": true
    }
  }
};